import { Route, Routes } from "react-router-dom";
import {
  ManagePromosAndNotifications,
  PromosAndNotificationsDetails,
  PromosAndNotificationsList,
} from "./containers";
import { ProtectedRoute } from "../../shared";

export const PromosAndNotificationRoutes = () => {
  return (
    <Routes>
      <Route index element={<PromosAndNotificationsList />} />
      <Route
        element={
          <ProtectedRoute allowedRoute={["promo-notification-create"]} />
        }
      >
        <Route path="create" element={<ManagePromosAndNotifications />} />
      </Route>
      <Route
        element={<ProtectedRoute allowedRoute={["promo-notification-view"]} />}
      >
        <Route path=":id" element={<PromosAndNotificationsDetails />} />
      </Route>
      <Route
        element={<ProtectedRoute allowedRoute={["promo-notification-modify"]} />}
      >
      <Route path=":id/edit" element={<ManagePromosAndNotifications />} />
      </Route>
    </Routes>
  );
};
